import { compact } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TextKey, RouteName } from '@mews-commander/enums';
import { hasCurrentEnterpriseServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { isCurrentEnterpriseActivityReportEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { getSimpleSearchResult } from './getSimpleSearchResult';
import { SearchResult } from './types';

export default createSelector(
    hasCurrentEnterpriseServiceId,
    isCurrentEnterpriseActivityReportEnabled,
    (hasReservableService: boolean, activityReportEnabled: boolean) =>
        compact<SearchResult>([
            hasReservableService
                ? getSimpleSearchResult({
                      routeName: RouteName.GuestInHouseReportIndex,
                      titleKey: TextKey.GuestInHouseReport,
                  })
                : null,
            getSimpleSearchResult({
                routeName: RouteName.EventReportIndex,
                titleKey: TextKey.EventReport,
            }),
            getSimpleSearchResult({
                routeName: RouteName.ResourceStatusReportIndex,
                titleKey: TextKey.ResourceStatusReport,
            }),
            activityReportEnabled
                ? getSimpleSearchResult({
                      routeName: RouteName.ActivityReportIndex,
                      titleKey: TextKey.ActivityReport,
                  })
                : null,
            hasReservableService
                ? getSimpleSearchResult({
                      routeName: RouteName.ProductReportIndex,
                      titleKey: TextKey.ProductReport,
                  })
                : null,
        ])
);
